import * as React from "react";
import { useModalContext } from "common/contexts";
import useGetPermissionsByScope from "hooks/useScopePermissions";
import EventProcedureStep from "security-app/components/SecurityEvents/EventProcedures/plugin/EventProcedureStepForm";
import EventProcedureModal from "./EventProcedureModal";
import EventProcedureDetailsDrawer from "./DetailsDrawer";
function EventProceduresModals() {
  const { modal, setModal, entity, setEntity } = useModalContext();
  const editedStep = modal === "EDIT-EVENT-PROCEDURE-STEP" ? entity : void 0;
  const { scopePermissions } = useGetPermissionsByScope(editedStep);
  const onClose = () => {
    setModal(null);
    setEntity(null);
  };
  switch (modal) {
    case "CREATE-EVENT-PROCEDURE":
      return /* @__PURE__ */ React.createElement(EventProcedureModal, { onClose, isCreate: true });
    case "EDIT-EVENT-PROCEDURE":
      return /* @__PURE__ */ React.createElement(EventProcedureModal, { onClose, eventProcedureId: entity });
    case "CREATE-EVENT-PROCEDURE-STEP":
      return /* @__PURE__ */ React.createElement(EventProcedureStep, { onClose });
    case "EDIT-EVENT-PROCEDURE-STEP":
      return /* @__PURE__ */ React.createElement(EventProcedureStep, { eventProcedureStep: editedStep, onClose, readOnly: !(scopePermissions == null ? void 0 : scopePermissions.is_mutable) });
    case "SHOW-EVENT-PROCEDURE-DETAILS":
      return /* @__PURE__ */ React.createElement(
        EventProcedureDetailsDrawer,
        {
          eventProcedure: entity,
          onClose
        }
      );
    default:
      return null;
  }
}
export default EventProceduresModals;
